import { render, staticRenderFns } from "./NavbarHeader.vue?vue&type=template&id=0b6de1b8&lang=pug&"
import script from "./NavbarHeader.vue?vue&type=script&lang=ts&"
export * from "./NavbarHeader.vue?vue&type=script&lang=ts&"
import style0 from "./NavbarHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports